import React, { HTMLAttributes } from "react";
import "./ExpandButton.scss";

interface IProps extends HTMLAttributes<HTMLButtonElement> {
    state: 'up' | 'down' | 'left' | 'right',
}

export const ExpandButton = React.forwardRef(({ state, className, ...buttonProps }: IProps, ref: any) => {
    const classes = [];
    if (className) classes.push(className);
    classes.push('expand-button');
    classes.push(`state-${state}`)
    return (
        <button ref={ref} className={classes.join(' ')} {...buttonProps}>
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
                <g id="Component_2_104" data-name="Component 2 – 104" transform="translate(50) rotate(90)">
                    <circle id="Ellipse_9" data-name="Ellipse 9" cx="25" cy="25" r="25" fill="#fff"/>
                    <g id="Group_49" data-name="Group 49" transform="translate(-299.683 1017.778) rotate(135)">
                        <rect id="Rectangle_271" data-name="Rectangle 271" width="16" height="4" rx="2" transform="translate(-941 475)" fill="#333"/>
                        <rect id="Rectangle_272" data-name="Rectangle 272" width="4" height="16" rx="2" transform="translate(-929 463)" fill="#333"/>
                    </g>
                </g>
            </svg>
        </button>
    )
});
